export default __webpack_public_path__ + "static/media/Website Image-1.5d73327e.png";